import { Controller } from '@hotwired/stimulus'
import $ from 'jquery';
import 'video.js/dist/video-js.css'
import videojs from 'video.js'

// Connects to data-controller='authorings'
export default class extends Controller {
  static values = {
    movies: Object,
    authoringList: Array,
    currentTime: Number,
    totalTime: Number,
    editable: Boolean,
    baseUrl: String,
    apiUrl: String,
    isAuthoring: Boolean,
    isMemoExists: Boolean
  }
  static targets = ['searchAuthoring', 'video', 'viewingTimeField', 'completeButton', 'memoEditForm', 'vertical', 'horizontal', 'frameHeight', 'frameWidth', 'verticalValue', 'horizontalValue', 'heightValue', 'widthValue', 'textArea', 'videoCanvas', 'startTimeArea']

  connect() {
    this.hasFetchError = false
    // turboのキャッシュにvideo jsは除く
    document.addEventListener('turbo:before-cache', () => {
      const video = videojs('movie')
      if (video != null) {
        video.dispose()
      }
    })
  }

  // ここに動画の初期読み込み設定を実装
  initialize() {
    if (this.isAuthoringValue) {
      const existingPlayer = videojs.getPlayer('movie');
      if (existingPlayer) {
        existingPlayer.dispose();
      }
    }
    const video = this.getVideo();
    video.ready(() => {
      if (video.readyState() > 0) {
        this.totalTimeValue = video.duration()
        this.loadMovieAuthorings()
      } else {
        video.on('loadedmetadata', () => {
          this.totalTimeValue = video.duration()
          this.loadMovieAuthorings()
        })
      }
    })
    // 再生時にカスタムコントロールを追加
    video.on('play', () => {
      this.addCustomControlsBtn(video);
    });
    // メモの編集画面の場合は動画プレビューさせる
    const hasMemoEditForm = this.hasMemoEditFormTarget;
    if (hasMemoEditForm) {
      this.loadMemoPreview(video);
    }
    const contentPlayer = document.getElementById('content-player');
    // フルスクリーンに収まるようにDOMを#movie配下に移動
    const telopElement = document.querySelector('#telop-element');
    const memoModal = document.querySelector('#memo-modal');
    const pointModal = document.querySelector('#point-modal');
    const quizModal = document.querySelector('#quiz-modal');
    const slideModal = document.querySelector('#slide-modal');
    const authoringList = document.querySelector('#authoring-list');
    const movieElement = document.querySelector('#movie');
    movieElement.appendChild(telopElement);
    movieElement.appendChild(memoModal);
    movieElement.appendChild(pointModal);
    movieElement.appendChild(quizModal);
    movieElement.appendChild(slideModal);
    movieElement.appendChild(authoringList);
    video.on('timeupdate', () => {
      const list = JSON.parse(contentPlayer.getAttribute('data-authorings-movies-value'))
      const currentTime = Math.floor(video.currentTime())
      // NOTE: 秒の切り替えタイミングで対象のオーサリングを表示するように
      if (currentTime != this.currentTimeValue && list != null) {
        this.currentTimeValue = currentTime
        this.loadTelops(currentTime, list.telops)
        this.loadMemos(currentTime, list.memos, hasMemoEditForm)
        this.loadSlides(currentTime, list.slides)
        this.loadQuizzes(currentTime, list.quizzes, video)
        this.loadPoints(currentTime, video, list.points)

        // 動画スキップ処理の前に、モーダルのクローズなどあるので、trimMovieは、最後に実行されるべき処理になります
        this.trimMovie(currentTime, video, list.trims)
      }
    });
  }

  // 指定時間に移動
  chapterJump() {
    const video = this.getVideo();
    const time = this.element.dataset.time
    video.currentTime(time);
  }

  searchAuthoring() {
    document.querySelectorAll('.authoring-list-item').forEach((list) => {
      if (this.searchAuthoringTarget.value === '' || list.getAttribute('data-authoring-title').includes(this.searchAuthoringTarget.value) ) {
        list.style.display = 'block'
      } else {
        list.style.display = 'none'
      }
    });
  }

  // オーサリング一覧の反映
  loadMovieAuthorings(){
    const movieId = $('#movie').data('movieId');
    // movieがない場合はAPIを呼ばせない
    if (movieId === undefined) {
      return {};
    }
    // 二回目以降はAPIの結果キャッシュを使う
    if (this.hasMoviesValue) {
      return this.moviesValue
    }
    this.moviesValue = {message: 'loading'};

    fetch(this.apiUrlValue, {
      method: 'GET',
    })
    .then(response => response.json())
    .then(data => {
      this.moviesValue = data;
      const video = this.getVideo()
      this.loadControlBar(video)
      this.loadMovieAuthoringList(video, this.moviesValue)
    })
    .catch((e) => {
      this.hasFetchError = true
      const video = this.getVideo()
      video.on('mouseout', function() {
        video.addClass('vjs-control-hide');
      });
      video.on('mouseover', function() {
        video.removeClass('vjs-control-hide');
      });
      const controlBar = video.getChild('controlBar');
      const hasBackButton = controlBar.children().some(
        child => child.name && child.name() === 'BackAuthoringButton'
      );
      const hasForwardButton = controlBar.children().some(
        child => child.name && child.name() === 'ForwardAuthoringButton'
      );

      if (!hasBackButton) {
        const backButton = this.createBackAuthoring(video);
        controlBar.addChild(backButton, {}, 1);
      }

      if (!hasForwardButton) {
        const forwardButton = this.createForwardAuthoring(video);
        controlBar.addChild(forwardButton, {}, 2);
      }
      // @todo エラーハンドリング
      console.log(e)
    })
  }

  loadControlBar(video){
    video.on('mouseout', function() {
      video.addClass('vjs-control-hide');
    });
    video.on('mouseover', function() {
      video.removeClass('vjs-control-hide');
    });
    // controlbar内にボタン追加
    video.getChild('controlBar').addChild(this.createBackAuthoring(video) , {}, 1);
    video.getChild('controlBar').addChild(this.createForwardAuthoring(video) , {}, 2);

    video.getChild('controlBar').addChild(this.createSubtitle(video) , {}, video.controlBar.children_.length - 2);

    video.getChild('controlBar').addChild(this.createAuthoringListToggle(video) , {}, video.controlBar.children_.length);
  }

  // 動画プレイヤー内の << ▶ >> ボタンを追加
  addCustomControlsBtn(video) {
    if (this.hasCustomControls) {
      return;
    }
    this.hasCustomControls = true;

    const videoCanvas = this.videoCanvasTarget;

    // ボタンコンテナを作成
    const controlWrapper = document.createElement('div');
    controlWrapper.className = 'custom-video-controls';
    videoCanvas.appendChild(controlWrapper);

    // 10秒戻るボタン作成（オーサリングがあればジャンプ）
    const backButton = document.createElement('button');
    backButton.className = 'custom-video-btn custom-back-btn';
    backButton.innerHTML = `
      <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L2 12L12 20V4Z"/>
        <path d="M22 4L12 12L22 20V4Z"/>
      </svg>
    `;
    backButton.onclick = () => {
      if (!this.hasFetchError && this.isAuthoringSettingExist()) {
        this.backAuthoring(video);
      } else {
        const currentTime = video.currentTime();
        video.currentTime(currentTime - 10);
      }
    };
    // 再生/停止ボタン作成
    const playPauseButton = document.createElement('button');
    playPauseButton.className = 'custom-video-btn custom-playpause-btn';
    playPauseButton.innerHTML = `
      <svg class="play-icon" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 5V19L19 12L8 5Z"/>
      </svg>
      <svg class="pause-icon" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" style="display: none;">
        <rect x="6" y="5" width="4" height="14"/>
        <rect x="14" y="5" width="4" height="14"/>
      </svg>
    `;
    const updatePlayPauseButton = () => {
      const playIcon = playPauseButton.querySelector('.play-icon');
      const pauseIcon = playPauseButton.querySelector('.pause-icon');

      if (video.paused()) {
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      } else {
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      }
    };
    playPauseButton.onclick = () => {
      if (video.paused()) {
        video.play();
      } else {
        video.pause();
      }
    };
    // 10秒進むボタン作成（オーサリングがあればジャンプ）
    const forwardButton = document.createElement('button');
    forwardButton.className = 'custom-video-btn custom-forward-btn';
    forwardButton.innerHTML = `
      <svg viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 4L12 12L2 20V4Z"/>
        <path d="M12 4L22 12L12 20V4Z"/>
      </svg>
    `;
    forwardButton.onclick = () => {
      if (!this.hasFetchError && this.isAuthoringSettingExist()) {
        this.forwardAuthoring(video);
      } else {
        const currentTime = video.currentTime();
        video.currentTime(currentTime + 10);
      }
    };
    controlWrapper.appendChild(backButton);
    controlWrapper.appendChild(playPauseButton);
    controlWrapper.appendChild(forwardButton);

    // マウスオーバー・タップ時の表示処理
    videoCanvas.addEventListener('mouseover', () => {
      controlWrapper.style.transition = 'none';
      controlWrapper.style.opacity = '1';
      controlWrapper.hidden = false;
    });
    videoCanvas.addEventListener('mouseout', () => {
      controlWrapper.hidden = true;
    });
    // 動画プレイヤーの要素を取得
    const videoPlayer = document.getElementById('movie');

    if (videoPlayer) {
      video.on('play', updatePlayPauseButton);
      video.on('pause', updatePlayPauseButton);
      // クラスの変化を監視する
      const observer = new MutationObserver(() => {
        const classList = videoPlayer.classList;
        const isHidden = classList.contains('vjs-control-hide'); // コントロールを隠す
        const isUserInactive = classList.contains('vjs-user-inactive'); // ユーザーが非アクティブ
        const isPlaying = classList.contains('vjs-playing'); // 再生中

        // `vjs-control-hide` がある場合 or `vjs-user-inactive` かつ `vjs-playing` の場合は非表示
        if (isHidden || (isUserInactive && isPlaying)) {
          controlWrapper.style.transition = 'opacity 0.5s ease';
          controlWrapper.style.opacity = '0';
          setTimeout(() => {
            if (controlWrapper.style.opacity === '0') {
              controlWrapper.style.display = 'none';
            }
          }, 500);
        } 
        else {
          controlWrapper.style.display = 'flex';
          controlWrapper.style.opacity = '1';
          video.trigger('useractive');
        }
      });
    
      observer.observe(videoPlayer, {attributes: true, attributeFilter: ['class']});
    }
    video.on('userinactive', () => {
      if (videoPlayer.classList.contains('vjs-playing')) {
        controlWrapper.style.opacity = '0';
        setTimeout(() => {
          if (controlWrapper.style.opacity === '0') {
            controlWrapper.hidden = true;
          }
        }, 500);
      }
    });

    video.on('useractive', () => {
      controlWrapper.hidden = false;
    });
    // 初期状態を設定
    updatePlayPauseButton();
  }

  loadMovieAuthoringList(video, authorings) {
    let list = []
    if (authorings.telops != null) {
      authorings.telops.forEach(telop => {
        list.push({id: telop.id, spot_time: telop.start_time, text: telop.text, type: 'telops'})
      })
    }
    if (authorings.memos != null) {
      authorings.memos.forEach(memo => {
        list.push({id: memo.id, spot_time: memo.start_time, text: memo.text, horizontal: memo.horizontal, vertical: memo.vertical, frame_height: memo.frame_height, frame_width: memo.frame_width, type: 'memos'})
      })
    }
    if (authorings.slides != null) {
      authorings.slides.forEach(slide => {
        list.push({id: slide.id, spot_time: slide.start_time, text: 'スライド', type: 'slides'})
      })
    }
    if (authorings.quizzes != null) {
      authorings.quizzes.forEach(quiz => {
        list.push({quiz: quiz.id, spot_time: quiz.spot_time, text: quiz.text, type: 'quizzes'})
      })
    }
    if (authorings.points != null) {
      authorings.points.forEach(point => {
        list.push({spot_time: point.spot_time, text: point.text, type: 'points'})
      })
    }
    if (authorings.chapters != null) {
      authorings.chapters.forEach(chapter => {
        list.push({id: chapter.id, spot_time: chapter.spot_time, text: chapter.title, type: 'chapters'})
      })
    }

    list.sort((a,b)=>{
      return this.stringTimeToNumber(a.spot_time) - this.stringTimeToNumber(b.spot_time)
     })

     this.authoringListValue = list

     this.setAuthoringListItems(video, list)
     this.setMarkerOnSeekBar(video, list)
  }

  setAuthoringListItems(video, list) {
    const items = document.getElementById('authoring-list-items');
    list.forEach(item => {
      const li = document.createElement('li');
      li.setAttribute('data-authoring-title', item.text);
      li.className = "list-group-item list-group-item-action list-group-item-dark authoring-list-item"
      const editUrl = this.editableValue ? `<div class='d-flex'><div class='me-auto'>${item.spot_time}</div><div><a href='${this.itemEditPath(item)}'>編集</a></div></div><br><div>${item.text}</div>` : `<div class='d-flex'><div class='me-auto'>${item.spot_time}</div></div><br><div>${item.text}</div>`
      li.innerHTML = editUrl

      items.appendChild(li);
      li.addEventListener('click', () => {
        const time = this.stringTimeToNumber(item.spot_time)
        video.currentTime(time);
      })
    })
  }

  // シークバーにマーカーを設定
  setMarkerOnSeekBar(video, list) {
    const total = this.totalTimeValue;
    const p = $(video.controlBar.progressControl.children_[0].el_);
    for (let i = 0; i < list.length; i++) {
      const spotTime = this.stringTimeToNumber(list[i].spot_time);
      const left = (spotTime / total * 100) + '%';
      const el = $('<div class="vjs-marker" style="left:' + left + '" data-time="' + spotTime + '"><span>' + list[i].text + '</span></div>');
      el.click(function () {
        video.currentTime($(this).data('time'));
      });
      p.append(el);
    }
  }

  loadTelops(currentTime, telops) {
    if (telops == null) { return; }
    let isTelopDisplay = false
    const telopElement = document.querySelector('#telop-element');
    telops.forEach(telop => {
      if (this.stringTimeToNumber(telop.start_time) <= currentTime && currentTime <= this.stringTimeToNumber(telop.end_time)) {
        telopElement.style.display = 'block';
        telopElement.innerHTML = `<span>${telop.text.replace(/\n/g,'<br>')}</span>`
        if (telop.position === 'up') {
          telopElement.style.bottom = ''
          telopElement.style.top = '5px'
        }  else {
          telopElement.style.bottom = '40px'
          telopElement.style.top = ''
        }
        isTelopDisplay = true
        return
      }
    })
    if (isTelopDisplay == false) {
      telopElement.style.display = 'none';
    }
  }

  loadMemos(currentTime, memos) {
    // 【ロジック概要】
    // loadMemos 関数は、メモの表示処理を担い、adjustMemoModal と fetchFontSizeValue に依存している。

    // 【fetchFontSizeValue の役割】
    // - メモモーダルのフォントサイズを取得する。
    // - 動画プレビューの動画サイズに合わせて、メモのフォントサイズを変更する。

    // 【loadMemos の役割】
    // - データベースに登録されているメモの情報を取得し、表示を管理する。
    // - データベースの情報を基に、メモモーダルのサイズ・位置・テキストを設定する。
    // - メモの表示時間が現在の再生時間と合致しているか判定する。

    // 【移行データ（過去データ）の処理について】
    // - 移行データのメモは、adjustMemoModal によってサイズ調整が行われる。
    // - メモのテキストがモーダル内に収まらない場合、adjustMemoModal 内ではみ出しを検出。
    // - テキストが横方向・縦方向のどちらにはみ出しているかを判定し、必要に応じてモーダルのサイズを自動調整し、テキストが適切に収まるようにする。

    if (memos == null) { return; }
    const memoModal = document.querySelector('#memo-modal');

    for (const memo of memos) {
      // モーダルの基本スタイルを設定
      memoModal.style.display = 'block';
      memoModal.style.position = 'absolute';
      memoModal.style.left = `${memo.horizontal}%`;
      memoModal.style.bottom = `${memo.vertical}%`;
      memoModal.style.width = `${memo.frame_width}%`;
      memoModal.style.height = `${memo.frame_height}%`;
      memoModal.style.fontSize = this.fetchFontSizeValue(memo.font_size_type);

      // テキストの内容とスタイルを設定
      const div = document.createElement('div');
      div.textContent = memo.text;
      memoModal.innerHTML = `<div>${div.innerHTML.replace(/\n/g, '<br>')}</div>`;

      // 収まりきらない場合に動的に高さを調整
      const contentDiv = memoModal.querySelector('div');
      const canvasHeight = this.videoCanvasTarget.offsetHeight; // 動画の高さを取得
      const canvasWidth = this.videoCanvasTarget.offsetWidth; // 動画の幅を取得

      // メモモーダルのサイズ調整(移行データ時用)
      const adjustedValues = this.adjustMemoModal(contentDiv, memoModal, canvasHeight, canvasWidth);
      // 計算結果をモーダルに適用
      const { height, width, bottom } = adjustedValues;
      if (height) memoModal.style.height = `${height}%`;
      if (width) memoModal.style.width = `${width}%`;
      if (bottom) memoModal.style.bottom = `${bottom}%`;

      if (this.stringTimeToNumber(memo.start_time) <= currentTime && currentTime <= this.stringTimeToNumber(memo.end_time)) {
        memoModal.style.opacity = '1'; // 不透明にする
        memoModal.style.pointerEvents = 'auto'; 
        break; // 条件に合致したらループを終了
      } else {
        memoModal.style.opacity = '0'; // 透明状態にする
        memoModal.style.pointerEvents = 'none'; 
      }
    }
  }

  // 移行データ用メモモーダルサイズ調整メソッド（メモ枠からテキストがはみ出していた場合に動作）
  adjustMemoModal(contentDiv, memoModal, canvasHeight, canvasWidth) {
    const isFullScreen = canvasHeight === window.innerHeight && canvasWidth === window.innerWidth;

    const adjustments = {};

    // 縦方向のはみ出し確認
    if (contentDiv.scrollHeight >= memoModal.offsetHeight && !isFullScreen) {
      const overflowHeight = contentDiv.scrollHeight - memoModal.offsetHeight; // はみ出た高さを計算
      const overflowHeightPercentage = (overflowHeight / canvasHeight) * 100; // はみ出た高さを％に変換

      // メモ枠の下端を取得
      const currentBottomPercent = parseFloat(memoModal.style.bottom); // 現在の bottom を取得（%）
      const canvasCenterY = canvasHeight / 2; // 動画の高さの中心点
      const memoBottomPositionPx = canvasHeight * (currentBottomPercent / 100);

      adjustments.height = parseFloat(memoModal.style.height) + (overflowHeightPercentage + 5); // テキストがメモモーダルの上下に5pxほど余白があるので+5を追加
      // モーダルの下端が動画の中心点より下にある場合
      if (memoBottomPositionPx > canvasCenterY) {
        adjustments.bottom = currentBottomPercent - (overflowHeightPercentage + 5);
      }

      // 保存
      this.savedHeightPercent = adjustments.height;
      this.savedBottomPercent = adjustments.bottom || currentBottomPercent;
    }

    // 横方向の確認
    if (contentDiv.scrollWidth + 3 >= memoModal.offsetWidth) { // テキストがメモモーダルの左端からおよそ3pxほど横の位置から開始されているので+3を追加
      const textWidth = contentDiv.scrollWidth;
      const textWidthPercent = (textWidth / canvasWidth) * 100;
      adjustments.width = parseFloat(memoModal.style.width) + textWidthPercent;
    }

    // 動画が最大化されたときの処理
    if (isFullScreen) {
      const scale = canvasHeight / this.videoCanvasTarget.offsetHeight;

      // 保存されている通常時のモーダルの高さ割合にスケールを掛けて、フルスクリーン時の高さを計算する
      adjustments.height = (this.savedHeightPercent || parseFloat(memoModal.style.height)) * scale;
      adjustments.bottom = (this.savedBottomPercent || parseFloat(memoModal.style.bottom)) * scale;
    }

    return adjustments;
  }

  loadSlides(currentTime, slides) {
    if (slides == null) { return; }
    let isSLideDisplay = false
    const slideModal = document.querySelector('#slide-modal');
    const imageTag = document.querySelector('#slide-image');
    slides.forEach(slide => {
      if (this.stringTimeToNumber(slide.start_time) <= currentTime && currentTime <= this.stringTimeToNumber(slide.end_time)) {
        // TODO: cdnでも画像表示にラグがある場合はhtmlで先に読みこむなどの対策を入れる
        imageTag.src = slide.file_url
        slideModal.style.display = 'block';
        isSLideDisplay = true
        this.showModalBackground()
        return
      }
    })
    if (isSLideDisplay == false) {
      slideModal.style.display = 'none';
      this.hideModalBackground()
    }
  }

  loadQuizzes(currentTime, quizzes, video) {
    if (quizzes == null) { return; }
    let isQuizDisplay = false
    const quizModal = document.querySelector('#quiz-modal');
    const quizQuestion = document.querySelector('#quiz-question');
    const quizModalText = document.querySelector('#quiz-modal-text');
    const quizModalButtons = document.querySelector('#quiz-modal-buttons');
    const quizAnswer = document.querySelector('#quiz-answer');
    const correctAnswer = document.querySelector('#correct-answer');
    const inCorrectAnswer = document.querySelector('#incorrect-answer');
    const alphabets = []
    for (let i = 'A'.charCodeAt(0); i <= 'Z'.charCodeAt(0); i++) {
      alphabets.push(String.fromCharCode([i]))
    }
    quizzes.forEach(quiz => {
      if (this.stringTimeToNumber(quiz.spot_time) <= currentTime && currentTime <= this.stringTimeToNumber(quiz.spot_time)) {
        quizModalButtons.innerHTML = ''
        for (let i = 0; i < quiz.choice_number; i++) {
          const btn = document.createElement('button');
          btn.innerText = alphabets[i]
          btn.className = 'btn btn-choice me-2'
          btn.onclick = () => {
            if (quiz.correct_number === i) {
              quizQuestion.style.display = 'none';
              inCorrectAnswer.style.display = 'none';
              correctAnswer.style.display = 'block';
              correctAnswer.innerHTML = `${quiz.correct_text.replace(/\n/g,'<br>')}`
              quizAnswer.dataset.jumpTime = quiz.correct_start_time;
            } else {
              quizQuestion.style.display = 'none';
              correctAnswer.style.display = 'none';
              inCorrectAnswer.style.display = 'block';
              inCorrectAnswer.innerHTML = `${quiz.incorrect_text.replace(/\n/g,'<br>')}`
              quizAnswer.dataset.jumpTime = quiz.incorrect_start_time;
            }
            quizAnswer.style.display = 'block';
          };
          quizModalButtons.appendChild(btn);
        }

        quizModal.style.display = 'block';
        quizModalText.innerHTML = `${quiz.text.replace(/\n/g,'<br>')}`
        isQuizDisplay = true
        video.pause();
        this.showModalBackground()

        return
      }
    })
    if (isQuizDisplay == false) {
      quizModal.style.display = 'none';
      quizQuestion.style.display = 'block';
      quizAnswer.style.display = 'none';
    }
  }

  closeQuizModal() {
    const video = this.getVideo();
    const modal = document.querySelector('#quiz-modal');
    modal.style.display = 'none';
    const quizAnswer = document.querySelector('#quiz-answer');
    quizAnswer.style.display = 'none';
    video.currentTime(this.stringTimeToNumber(quizAnswer.dataset.jumpTime));
    video.play()
    this.hideModalBackground()
  }

  loadPoints(currentTime, video, points) {
    if (points == null) { return; }
    let isPointDisplay = false
    const pointModal = document.querySelector('#point-modal');
    const pointModalText = document.querySelector('#point-modal-text');
    points.forEach(point => {
      if (this.stringTimeToNumber(point.spot_time) <= currentTime && currentTime <= this.stringTimeToNumber(point.spot_time)) {
        pointModal.style.display = 'block';
        pointModalText.innerHTML = `${point.text.replace(/\n/g,'<br>')}`
        isPointDisplay = true
        video.pause();
        this.showModalBackground()

        return
      }
    })
    if (isPointDisplay == false) {
      pointModal.style.display = 'none';
    }
  }

  // リアルタイムメモ編集用関数
  loadMemoPreview(video) {
    // 【概要】
    // メモ編集フォームに入力された情報と動画の再生状態に基づいて、動画プレビュー上に表示されるメモモーダルの位置、サイズ、テキスト内容を設定および更新。
    // 具体的に、フォームから得た値（縦位置、横位置、縦サイズ、横サイズ、フォントサイズ）を元に、メモモーダルの初期表示を行い、テキストエリアの入力に応じてその内容を更新。
    // また、テキストがモーダル内に収まらない場合は、adjustMemoModal 関数を呼び出して自動でサイズや位置を調整し、syncMemoModalAdjustments を介してその結果を反映。

    // 【依存関数】
    // ・fetchFontSizeValue：動画のサイズ等に応じた適切なフォントサイズを適応。
    // ・adjustMemoModal：メモモーダル内のテキストがはみ出している場合、縦方向および横方向の調整値（高さ、下端位置、幅）を計算。
    // ・syncMemoModalAdjustments：adjustMemoModal から返された調整値をメモモーダルのスタイルに反映し、テキストが正しく表示されるよう設定。

    // 【概要】
    // 1. 既存メモ編集の場合:
    //    - 編集フォームから開始時刻を取得し、動画をその時刻にジャンプ。
    // 2. 初期設定:
    //    - フォームに入力された縦位置、横位置、サイズ、フォントサイズのテキスト値を、メモモーダルの各スタイルに反映。
    // 3. 調整処理:
    //    - syncMemoModalAdjustments（内部で adjustMemoModal を呼び出す）により、テキストがモーダル内に収まらない場合に、必要なサイズ/位置を調整し適応。
    // 4. イベントリスナー:
    //    - テキストエリアおよび各種設定項目の入力イベントにより、ユーザーの入力変更をリアルタイムに反映。
    const memoModal = document.querySelector('#memo-modal');
    memoModal.style.display = 'block';

    // 1. 既存メモ編集の場合:編集フォームから開始時刻を取得し、動画をその時刻にジャンプ。
    if (this.isMemoExistsValue){
      const startTime = this.startTimeAreaTarget;
      video.currentTime(this.stringTimeToNumber(startTime.value));
    }

    // 2. 初期設定:- フォームに入力された縦位置、横位置、サイズ、フォントサイズのテキスト値を、メモモーダルの各スタイルに反映。
    // 縦位置設定
    const vertical = this.verticalTarget;
    const verticalValueElement = this.verticalValueTarget;
    memoModal.style.bottom = `${vertical.value}%`;
    // 横位置設定
    const horizontal = this.horizontalTarget;
    const horizontalValueElement = this.horizontalValueTarget;
    memoModal.style.left = `${horizontal.value}%`;
    // 縦サイズ設定
    const height = this.frameHeightTarget;
    const heightValueElement = this.heightValueTarget;
    memoModal.style.height = `${height.value}%`;
    // 横サイズ設定
    const width = this.frameWidthTarget;
    const widthValueElement = this.widthValueTarget;
    memoModal.style.width = `${width.value}%`;
    //フォントサイズ設定
    memoModal.style.fontSize = this.fetchFontSizeValue('normal');

    const updateMemoTextContent = () => {
      const textArea = this.textAreaTarget;
      const processTextForMemo = (text) => {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML.replace(/\n/g, '<br>');
      };
      memoModal.innerHTML = `<div>${processTextForMemo(textArea.value)}</div>`;
    };
    // テキストを反映
    updateMemoTextContent();

    // 3. 調整処理:syncMemoModalAdjustments（内部で adjustMemoModal を呼び出す）により、テキストがモーダル内に収まらない場合に、必要なサイズ/位置を調整し適応。
    // (基本的にメモモーダル内にテキストが収まっていない移行データ時に動作)
    this.syncMemoModalAdjustments(memoModal);

    // 4. イベントリスナー:テキストエリアおよび各種設定項目の入力イベントにより、ユーザーの入力変更をリアルタイムに反映。
    const textArea = this.textAreaTarget;
    textArea.addEventListener('input', () => {
      updateMemoTextContent();
      // 同期処理を呼び出して調整結果を反映する
      this.syncMemoModalAdjustments(memoModal);
    });
    vertical.addEventListener(`input`, () => {
      const verticalValue = parseInt(vertical.value)
      const isPlus = verticalValue >= 0
      const heightValue = parseInt(height.value)
      if (110 < Math.abs(verticalValue) + heightValue) {
        alert('動画の枠内で設定してください');
        vertical.value = isPlus ? (verticalValue - 15) : (verticalValue + 15)
      }
      memoModal.style.bottom = `${vertical.value}%`
      verticalValueElement.innerText = `Value: ${vertical.value}`;
    });
    horizontal.addEventListener(`input`, () => {
      const horizontalValue = parseInt(horizontal.value)
      const isPlus = horizontalValue >= 0
      const widthValue = parseInt(width.value)
      if (110 < Math.abs(horizontalValue) + widthValue) {
        alert('動画の枠内で設定してください');
        horizontal.value = isPlus ? (horizontalValue - 15) : (horizontalValue + 15)
      }
      memoModal.style.left = `${horizontal.value}%`
      horizontalValueElement.innerText = `Value: ${horizontal.value}`;
    });
    height.addEventListener(`input`, () => {
      const currentHeightValue = parseInt(height.value)
      const verticalValue = parseInt(vertical.value)
      if (105 < Math.abs(verticalValue) + currentHeightValue) {
        alert('動画の枠内で設定してください');
        height.value = currentHeightValue - 15
      }
      memoModal.style.height = `${height.value}%`
      heightValueElement.innerText = `Value: ${height.value}`;
    });
    width.addEventListener(`input`, () => {
      const currentWidthValue = parseInt(width.value)
      const horizontalValue = parseInt(horizontal.value)
      if (105 < Math.abs(horizontalValue) + currentWidthValue) {
        alert('動画の枠内で設定してください');
        width.value = currentWidthValue - 15
      }
      memoModal.style.width = `${width.value}%`
      widthValueElement.innerText = `Value: ${width.value}`;
    });
  }

  // adjustMemoModal を呼び出すことにより、テキストがモーダル内に収まらない場合に、必要なサイズ/位置を調整しフォームに適応。
  syncMemoModalAdjustments(memoModal) {
    // 動画プレイヤーのDOMからキャンバスサイズを取得（動画が再生していないとtargetが使用できないのでquerySelectorを使用。）
    const canvasElement = document.querySelector('#movie_html5_api');
    const canvasHeight = canvasElement.offsetHeight;
    const canvasWidth = canvasElement.offsetWidth;

    // memoModal 内のテキスト部分を取得
    const contentDiv = memoModal.querySelector('div');
    // 調整関数を呼び出して、サイズ・位置の調整結果を取得
    const adjustments = this.adjustMemoModal(contentDiv, memoModal, canvasHeight, canvasWidth);
    if (adjustments.height) {
      memoModal.style.height = `${adjustments.height}%`;
    }
    if (adjustments.bottom) {
      memoModal.style.bottom = `${adjustments.bottom}%`;
    }
    if (adjustments.width) {
      memoModal.style.width = `${adjustments.width}%`;
    }

    // 各入力フォームに調整後の値を反映して、最新値を表示する
    const vertical = this.verticalTarget;
    const verticalValueElement = this.verticalValueTarget;
    vertical.value = parseFloat(memoModal.style.bottom);
    verticalValueElement.innerText = `Value: ${vertical.value}`;

    const horizontal = this.horizontalTarget;
    const horizontalValueElement = this.horizontalValueTarget;
    horizontal.value = parseFloat(memoModal.style.left);
    horizontalValueElement.innerText = `Value: ${horizontal.value}`;

    const height = this.frameHeightTarget;
    const heightValueElement = this.heightValueTarget;
    height.value = parseFloat(memoModal.style.height);
    heightValueElement.innerText = `Value: ${height.value}`;

    const width = this.frameWidthTarget;
    const widthValueElement = this.widthValueTarget;
    width.value = parseFloat(memoModal.style.width);
    widthValueElement.innerText = `Value: ${width.value}`;
  }

  trimMovie(currentTime, video, trims) {
    if (trims == null) { return; }
    trims.forEach(trim => {
      const startTime = this.stringTimeToNumber(trim.start_time)
      const endTime = this.stringTimeToNumber(trim.end_time)
      if (startTime <= currentTime && currentTime <= endTime) {
        video.currentTime(endTime + 1);
      }
    })
  }

  nextPoint() {
    const video = this.getVideo();
    var modal = document.querySelector('#point-modal');
    modal.style.display = 'none';
    video.play();
    this.hideModalBackground()
  }

  // VideoJsを取得
  getVideo(){
    const video = videojs('movie',{
      autoplay: false,
      fluid: true, // 動画コンテンツを親要素いっぱいに広げる
      loop: false, // 繰り返し再生無効
      controls: true, // コントローラ表示
      preload: 'auto', // videoタグがロードされた瞬間に動画をダウンロード
      playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2], // 再生速度の倍率
      inactivityTimeout: 3000, // コントロールバー常時表示
      preferFullWindow: true, // VideoJsフルスクリーン対応
      controlBar: {
        'pictureInPictureToggle': false // pictureInPictureアイコンの表示判定
      },
      languages: {
        ja: {
          'Play': '再生',
          'Pause': '停止',
          'Play Video': '再生',
          'Mute': '消音',
          'Playback Rate': '再生速度',
          'Picture-in-Picture': 'ピクチャインピクチャ',
          'Fullscreen': '全画面表示',
          'Non-Fullscreen': '通常表示'
        }
      }, // 日本語の言語対応
      language: 'ja'   // 言語を日本語に設定,
    });

    // キーボードのキー押下時の動画プレイヤー操作設定
    document.addEventListener('keydown', (event) => {
      const activeElement = document.activeElement;
      const video = videojs.getPlayers()['movie']

      // オーサリングメモ編集画面の操作への影響をなくす為、スライダー (input[type='range']) がフォーカスされている場合は何もしない
      if (activeElement && activeElement.tagName === 'INPUT' && activeElement.type === 'range') {
        return;
      }

      // スペースキーで再生・一時停止を切り替え
      if (event.key === ' ') {
        event.preventDefault();
        if (video.paused()) {
          video.play();
        } else {
          video.pause();
        }
        event.stopImmediatePropagation();
      }

      // 左矢印キー（←）で巻き戻しor前のオーサリングへ
      if (event.key === 'ArrowLeft') {
        if (!this.hasFetchError && this.isAuthoringSettingExist()) {
          this.backAuthoring(video);
        } else {
          const currentTime = video.currentTime();
          video.currentTime(currentTime - 10);
        }
        event.stopImmediatePropagation();
      }

      // 右矢印キー（→）で早送りor次のオーサリングへ
      if (event.key === 'ArrowRight') {
        if (!this.hasFetchError && this.isAuthoringSettingExist()) {
          this.forwardAuthoring(video);
        } else {
          const currentTime = video.currentTime();
          video.currentTime(currentTime + 10);
        }
        event.stopImmediatePropagation();
      }
    }, true);

    return video;
  }

  hideModalBackground() {
    const modalBackground = document.querySelector('#modal-background');
    modalBackground.style.display = 'none';
  }

  showModalBackground() {
    const modalBackground = document.querySelector('#modal-background');
    modalBackground.style.display = 'block';
  }


  // 次へ
  forwardAuthoring(video) {
    const currentTime = video.currentTime();
    for (let i = 0; i < this.authoringListValue.length; i++) {
      const spotTime = this.stringTimeToNumber(this.authoringListValue[i].spot_time)
      if (spotTime > currentTime) {
        video.currentTime(spotTime);
        break;
      }
    }
  }

  // 戻る
  backAuthoring(video) {
    const currentTime = video.currentTime();
    for (let i = this.authoringListValue.length - 1; i >= 0; i--) {
      const spotTime = this.stringTimeToNumber(this.authoringListValue[i].spot_time)
      if (spotTime + 0.5 < currentTime) {
        video.currentTime(spotTime);
        return;
      }
    }
  }


  // controlbar内のbackボタンの作成
  createBackAuthoring(video) {
    const element = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-backward" viewBox="0 0 16 16" style="cursor: pointer; margin-top: 10px;">
       <path d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z"/>
      </svg>
    `
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    const result = new ClickableComponent(video);
    result.el().innerHTML = element;
    result.handleClick = () => {
      // オーサリングが設定されていれば前のオーサリングへ/設定されていなければ10秒戻す
      if (!this.hasFetchError && this.isAuthoringSettingExist()){
        this.backAuthoring(video)
      } else {
        const currentTime = video.currentTime();
        video.currentTime(currentTime - 10);
      }
    }
    result.name = () => 'BackAuthoringButton';
    return result;
  }

  // controlbar内の次へボタンの作成
  createForwardAuthoring(video) {
    const element = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-skip-forward" viewBox="0 0 16 16" style="cursor: pointer; margin-top: 10px;">
        <path d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z"/>
      </svg>
    `
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    const result = new ClickableComponent(video);
    result.el().innerHTML = element;
    result.handleClick = () => {
      // オーサリングが設定されていれば次のオーサリングへ/設定されていなければ10秒進める
      if (!this.hasFetchError && this.isAuthoringSettingExist()){
        this.forwardAuthoring(video)
      } else {
        const currentTime = video.currentTime();
        video.currentTime(currentTime + 10);
      }
    }
    result.name = () => 'ForwardAuthoringButton';
    return result;
  }

  // controlbar内のオーサリングリストトグルボタンの作成
  createAuthoringListToggle(video) {
    const element = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul" viewBox="0 0 16 16" style="cursor: pointer; margin-top: 10px;">
        <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
      </svg>
    `
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    const result = new ClickableComponent(video);
    result.el().innerHTML = element;
    result.handleClick = () => {
      const list = document.getElementById('authoring-list');
      if (list.style.display === 'none') {
        list.style.display = 'block';
      } else {
        list.style.display = 'none';
      }
    }
    return result;
  }

  // controlbar内の字幕ボタンの作成
  createSubtitle(video) {
    const element = `
      <div class="position-relative d-inline-block h-100 w-100">
        <!-- SVGアイコン -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
          class="bi bi-list-ul subtitle-icon" viewBox="0 0 22 22" style="cursor: pointer; margin-top: 10px; fill: red;">
          <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"/>
        </svg>
        <!-- プルダウンメニュー -->
        <div class="subtitle-dropdown d-none position-absolute" style="bottom: 24px; left: 0;
             background: black; border: 1px solid #ccc; border-radius: 4px; z-index: 1000; color: white;">
          <div class="subtitle-option" data-value="on" style="padding: 5px 10px; cursor: pointer;">
            字幕ON
          </div>
          <div class="subtitle-option" data-value="off" style="padding: 5px 10px; cursor: pointer;">
            字幕OFF
          </div>
        </div>
      </div>
    `;
    const ClickableComponent = videojs.getComponent('ClickableComponent');
    const result = new ClickableComponent(video);

    if (this.moviesValue.subtitles == null) {return result;}

    // 動画字幕設定
    // 別処理だとtrackがうまく取得できないので、字幕設定に合わせてボタンのtoggleを仕込む
    const track = video.addTextTrack('subtitles', '日本語の字幕', 'ja');
    track.mode = 'hidden';

    this.moviesValue.subtitles.forEach(sub => {
      let classes = ''
      // フォントサイズ
      if (sub.font_size_type != null) {
        classes += `.font-size-${sub.font_size_type}`
      }
      // フォントカラー
      if (sub.font_color_type != null) {
        classes += `.${sub.font_color_type}`
      }
      // 背景色
      if (sub.background_color_type != null) {
        classes += `.background-${sub.background_color_type}`
      }
      const cueText = `<c${classes}>${sub.text}</c>`

      // https://developer.mozilla.org/ja/docs/Web/API/VTTCue
      const cue = new VTTCue(this.stringTimeToNumber(sub.start_time), this.stringTimeToNumber(sub.end_time), cueText);

      // INFO: line は高さの位置調整
      cue.line = sub.vertical !== null && sub.vertical !== undefined ? sub.vertical : 'auto';

      // INFO: position は横の位置調整
      cue.position = sub.horizontal || 50;

      // INFO: align は左寄せ、中央、右寄せの設定
      // start / center / end / left / right
      cue.align = 'center';

      track.addCue(cue);
    })

    result.el().innerHTML = element;
    // ここで、親要素（字幕ボタン）のクリック・タッチイベントを設定
    const container = result.el();
    const svgIcon = container.querySelector('.subtitle-icon'); 
    const dropdown = container.querySelector('.subtitle-dropdown');

    // 初期ロード時にボタンの色を字幕の状態に合わせる
    svgIcon.style.fill = track.mode === 'showing' ? 'red' : 'currentColor';

    // 親要素全体に対してクリックとタッチイベントを設定
    container.addEventListener('click', () => {
      // タップ/クリックされた場所に関わらず、プルダウンの表示をトグル
      dropdown.classList.toggle('d-none');
    });

    container.addEventListener('touchstart', () => {
      dropdown.classList.toggle('d-none');
    });
    // プルダウンメニュー内のオプションがクリックまたはタップされたら処理する
    const handleSubtitleSelection = (event) => {
      const optionEl = event.target.closest('.subtitle-option');
      const value = optionEl.dataset.value;
      if (value === 'on') {
        track.mode = 'showing';
        svgIcon.style.fill = 'red'; // ボタンを赤くする
      } else if (value === 'off') {
        track.mode = 'hidden';
        svgIcon.style.fill = 'currentColor'; // 元の色に戻す
      }
      // クリックイベントの処理が終わった後にメニューを閉じる
      setTimeout(() => {
        dropdown.classList.add('d-none'); // メニューを非表示にする
      }, 0);
    };
    // クリックとタッチの両方に対応
    dropdown.addEventListener('click', handleSubtitleSelection);
    dropdown.addEventListener('touchend', handleSubtitleSelection);

    return result;
  }

  stringTimeToNumber(time) {
    const array = time.split(':');
    return (parseInt(array[0], 10) * 60 * 60) + (parseInt(array[1], 10) * 60) + parseInt(array[2], 10)
  }

  itemEditPath(item) {
    return this.baseUrlValue + `/${item.type}/${item.id}/edit`
  }

  fetchFontSizeValue(sizeName) {
    const hasMemoEditForm = this.hasMemoEditFormTarget;
    if (!this.isAuthoringValue && !hasMemoEditForm) {
      switch (sizeName) {
        case 'small':
          return '1.2vw';
        case 'big':
          return '2.2vw';
        default:
          return '1.7vw';
      }
    } else {
      switch (sizeName) {
        case 'small':
          return '0.7vw';
        case 'big':
          return '1.7vw';
        default:
          return '1.2vw';
      }
    }
  }

  fetchColorValue(colorName) {
    switch (colorName) {
      case 'black':
        return 'black';
      case 'red':
        return '#cd514f';
      case 'blue':
        return '#004a7a';
      default:
        return 'white'
      }
  }

  // オーサリングが設定されているか？
  // 字幕/動画カットは対象外
  isAuthoringSettingExist() {
    let settingExist = false;
    if (this.moviesValue.telops.length !== 0) {
      settingExist = true;
    }

    if (this.moviesValue.chapters.length !== 0) {
      settingExist = true;
    }

    if (this.moviesValue.memos.length !== 0) {
      settingExist = true;
    }

    if (this.moviesValue.points.length !== 0) {
      settingExist = true;
    }

    if (this.moviesValue.quizzes.length !== 0) {
      settingExist = true;
    }

    if (this.moviesValue.slides.length !== 0) {
      settingExist = true;
    }

    return settingExist;
  }
}
